var exports = {
  "x": "xcc377c0b--ed30a5--button",
  "I": "xcc377c0b--ed30a5--fullWidth",
};

module.exports = exports;
